// extracted by mini-css-extract-plugin
module.exports = {"container":"home_container__ucQ-a","header":"home_header__x7eDG","active":"home_active__3i4qo","header1":"home_header1__qZYzw","provider":"home_provider__3UucA"};